import { ProtocolContentData } from "../../protocol";
export default class NavigationData extends ProtocolContentData {
    hdg_gyro;
    gyroA;
    speed_error_correction;
    hdg_magn;
    mag_dev;
    mag_var;
    rot;
    stw_ctw;
    dist_og;
    dist_tw;
    roll;
    pitch;
    roll_period;
    constructor(hdg_gyro, gyroA, speed_error_correction, hdg_magn, mag_dev, mag_var, rot, stw_ctw, dist_og, dist_tw, roll, pitch, roll_period) {
        super();
        this.hdg_gyro = hdg_gyro;
        this.gyroA = gyroA;
        this.speed_error_correction = speed_error_correction;
        this.hdg_magn = hdg_magn;
        this.mag_dev = mag_dev;
        this.mag_var = mag_var;
        this.rot = rot;
        this.stw_ctw = stw_ctw;
        this.dist_og = dist_og;
        this.dist_tw = dist_tw;
        this.roll = roll;
        this.pitch = pitch;
        this.roll_period = roll_period;
    }
}
//# sourceMappingURL=NavigationData.js.map